import React, { useState, useCallback } from 'react';
import { IUnsavedNavigationDialogResult } from 'types/dialogs';
import UnsavedNavigationDialog from './UnsavedNavigationDialog';

const useUnsavedNavigationDialog = () => {
	const [unsavedNavigationDialogJsx, setUnsavedNavigationDialogJsx] =
		useState<React.JSX.Element | null>(null);

	const openUnsavedNavigationDialog = useCallback(
		() =>
			new Promise<IUnsavedNavigationDialogResult>((resolve) => {
				setUnsavedNavigationDialogJsx(
					<UnsavedNavigationDialog
						onClose={(res) => {
							setUnsavedNavigationDialogJsx(null);
							resolve(res);
						}}
					/>
				);
			}),
		[]
	);

	return { unsavedNavigationDialogJsx, openUnsavedNavigationDialog };
};

export default useUnsavedNavigationDialog;
